import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import {NeuroMessage} from '../../../neuro-guide/components';

const ChartFooter = ({ config, setRenderQuestionGroup, renderQuestionGroup }) => {
  const isActiveClass = (isActive) => classnames('', {active: isActive});
  const buttonText = renderQuestionGroup ? 'showInsights' : 'hideInsights';

  return (
    <>
      { config?.footer.isEnabled &&
        <div className="chartFooter">
          <div className='chartFooterContent'>
            <div><NeuroMessage id='whyImportant' /></div>
            <div><NeuroMessage shouldHideIfNotFound={true} id={`${config.chartKey}.whyImportant`} /></div>
          </div>
          <div className='chartFooterNav'>
            { config?.insights.isEnabled && <button className={`btn chart__button ${isActiveClass(renderQuestionGroup)}`} onClick={() => setRenderQuestionGroup(!renderQuestionGroup) }><NeuroMessage shouldHideIfNotFound={true} id={`${buttonText}`} /><i className='fa fa-star'/></button>}
          </div>
        </div>
      }
    </>
  );
};

ChartFooter.propTypes = {
  config: PropTypes.shape({
    footer: PropTypes.shape({
      isEnabled: PropTypes.bool
    }),
    chartKey: PropTypes.string,
    insights: PropTypes.shape({
      isEnabled: PropTypes.bool
    })
  }),
  setRenderQuestionGroup: PropTypes.func,
  renderQuestionGroup: PropTypes.bool
};

export default ChartFooter;